<template>
  <div :class="divClass" v-b-tooltip.hover :title="acreditacionText">
    <img
      src="@/assets/img/iconos/acreditacion-1-bl.svg"
      class="mr-1"
      v-if="acreditacion.anios === 1"
    />
    <img
      src="@/assets/img/iconos/acreditacion-2-bl.svg"
      class="mr-1"
      v-if="acreditacion.anios === 2"
    />
    <img
      src="@/assets/img/iconos/acreditacion-3-bl.svg"
      class="mr-1"
      v-if="acreditacion.anios === 3"
    />
    <img
      src="@/assets/img/iconos/acreditacion-4-bl.svg"
      class="mr-1"
      v-if="acreditacion.anios === 4"
    />
    <img
      src="@/assets/img/iconos/acreditacion-5-bl.svg"
      class="mr-1"
      v-if="acreditacion.anios === 5"
    />
    <img
      src="@/assets/img/iconos/acreditacion-6-bl.svg"
      class="mr-1"
      v-if="acreditacion.anios === 6"
    />
    <img
      src="@/assets/img/iconos/acreditacion-7-bl.svg"
      class="mr-1"
      v-if="acreditacion.anios === 7"
    />
  </div>
</template>

<script>
export default {
  name: "AñoAcreditacionBlanco",
  props: {
    acreditacion: {
      type: Object
    },
    divClass: {
      type: String
    }
  },
  computed: {
    acreditacionText() {
      let text = this.acreditacion.anios === 1 ? "año" : "años";
      return `Institución acreditada: ${this.acreditacion.anios} ${text}`;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/iconos/AñoAcreditacionBlanco.vue